/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var CopyIcon16Regular = forwardRef('CopyIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.752 0a2.75 2.75 0 0 0-2.75 2.75v7.5A2.75 2.75 0 0 0 4.752 13h5.496a2.75 2.75 0 0 0 2.75-2.75v-7.5A2.75 2.75 0 0 0 10.248 0H4.752Zm-1.25 2.75c0-.69.56-1.25 1.25-1.25h5.496c.69 0 1.25.56 1.25 1.25v7.5c0 .69-.56 1.25-1.25 1.25H4.752c-.69 0-1.25-.56-1.25-1.25v-7.5Z" }),
        React.createElement("path", { d: "M15.5 5.5a.75.75 0 0 0-1.5 0v5.247a3.25 3.25 0 0 1-3.25 3.25H6.5a.75.75 0 0 0 0 1.5h4.25a4.75 4.75 0 0 0 4.75-4.75V5.5Z" })));
});
